import actions from '../../../actions'

export default {
  table: {
    noApi: true,
    specialFlag: {
      aggregate: false
    },
    sorting: {
      sortBy: 'debrisType.code',
      sortDesc: false
    },
    filters: [
      { name: 'departmentId', filterBy: '', hide: true, required: true }
    ],
    parameters: [
      { name: 'debrisCode', text: 'Kod odpadu', value: 'debrisType.code', show: true },
      { name: 'debrisType', text: 'Typ odpadu', value: 'debrisType.displayName', show: true, length: 100 },
      { name: 'price', text: 'name', value: 'price', multiple: 'prices', sortable: false, show: false },
      { name: 'actions', text: '', value: 'actions', sortable: false, show: true }
    ],
    actions: [
      { ...actions.editDebrisPrice, icon: 'edytuj' },
      { ...actions.deleteDebrisPrice, icon: 'usun' }
    ],
    menu: [
      { ...actions.editTransportPrice },
      { ...actions.deleteTransportPrice }
    ]
  }
}
